/**
 * Created by akrio on 2018/3/23.
 */
import {
  PAYPAL_INFO,
  BEFORE_PAY_PAGE,
  PAY_PAGE_TYPE,
  PAY_PAGE_TYPE_ID,
} from "../mutation-types";

export default {
  state: {
    payPageType: null, // 支付之前订阅类型
    payPageTypeId: null, // 支付之前订阅类型对应id
    beforePayPage: null, // 页面支付成功回调地址
    paypalInfo: null, // paypal支付之前信息
  },
  mutations: {
    [PAYPAL_INFO](state, info) {
      state.paypalInfo = info;
    },
    [BEFORE_PAY_PAGE](state, page) {
      if (page) {
        state.beforePayPage = page;
      }
    },
    [PAY_PAGE_TYPE](state, type) {
      state.payPageType = type;
    },
    [PAY_PAGE_TYPE_ID](state, id) {
      state.payPageTypeId = id;
    },
  },
  getters: {
    [BEFORE_PAY_PAGE](state) {
      return state.beforePayPage;
    },
    [PAY_PAGE_TYPE](state) {
      return state.payPageType;
    },
    [PAY_PAGE_TYPE_ID](state) {
      return state.payPageTypeId;
    },
    [PAYPAL_INFO](state) {
      return state.paypalInfo;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/payment.js